import type { ReactNode } from 'react';
import styles from './StatusBadge.module.css';

type StatusBadgeVariant = 'in-progress';

type StatusBadgeProps = {
  children: ReactNode;
  variant: StatusBadgeVariant;
};

const VARIANT_CLASS: Record<StatusBadgeVariant, string> = {
  'in-progress': styles.inProgress,
};

export default function StatusBadge({ children, variant }: StatusBadgeProps) {
  return (
    <span className={[styles.badge, VARIANT_CLASS[variant]].join(' ')}>
      {children}
    </span>
  );
}
